import { Link } from "react-router-dom";
import { memo } from "react";
import type { VideoItem } from "@/mocks/videos";
import { formatCount, getCategoryById } from "@/utils/video";

interface VideoCardProps {
  video: VideoItem;
  index?: number;
}

function VideoCard({ video, index = 0 }: VideoCardProps) {
  const category = getCategoryById(video.category);

  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex animate-fadeUp flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} - 糖心Vlog`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 bottom-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          {video.duration}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {category?.name}
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {video.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {video.description}
        </p>

        <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line" /> {video.publishedAt}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-play-circle-line" /> {formatCount(video.views)} 次播放
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-heart-line" /> {formatCount(video.likes)}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default memo(VideoCard);